import { render, staticRenderFns } from "./ProjectEdit.vue?vue&type=template&id=4939eb3f&scoped=true"
import script from "./ProjectEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectEdit.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ProjectEdit.vue?vue&type=style&index=0&id=4939eb3f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4939eb3f",
  null
  
)

export default component.exports